// Formats a US phone number as the visitor types: "4157282623" -> "(415) 728-2623".
//
// Separators appear only once the next digit exists, so the value never ends in
// "(415) " or "728-" — otherwise backspacing would delete the separator, the input
// would reformat, and it would put it straight back.
//
// A leading US country code from autofill or paste ("+1 415…", "1 415…") is dropped.
// An international number ("+86 …") is left exactly as typed.
export function formatPhone(raw) {
  const value = String(raw || '');
  if (/^\s*\+\s*[02-9]/.test(value)) return value; // a non-US country code

  let digits = value.replace(/\D/g, '');
  if (digits.length > 10 && digits.startsWith('1')) digits = digits.slice(1);
  digits = digits.slice(0, 10);

  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
